import { DetailAbsen } from "@services/dtos/school.dto";
import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const AbsenceDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Absensi", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Absensi",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          <div className="tw-text-primary-hg tw-text-xs">Tanggal Absen</div>
          <div>
            {moment(state.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
          </div>
        </div>

        <div className="tw-bg-other-100 tw-rounded-lg card-body tw-mt-4">
          <div className="tw-text-primary-hg tw-text-xs tw-mb-2">
            Detail Absen
          </div>
          {state.detailAbsen?.map((item: DetailAbsen, idx: number) => (
            <div key={idx} className="tw-mb-4">
              <div className="tw-text-xs tw-mb-1">{item.mapel ?? "-"}</div>
              <div className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-green-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-green-800 tw-ring-1 tw-ring-green-600/20 tw-ring-inset">
                Hadir: {item.hadir}
              </div>
              <div className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-red-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-red-700 tw-ring-1 tw-ring-red-600/10 tw-ring-inset tw-ms-2">
                Alpa: {item.alpa}
              </div>
              <div className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-yellow-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-yellow-800 tw-ring-1 tw-ring-yellow-600/20 tw-ring-inset tw-ms-2">
                Sakit: {item.sakit}
              </div>
              <div className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-blue-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-blue-700 tw-ring-1 tw-ring-blue-700/10 tw-ring-inset tw-ms-2">
                Izin: {item.ijin}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
